import React from 'react';
import { Link as MuiLink, Stack } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { normalizeLanguage } from '../../constants/Languages';
import { MARKETING_LANGUAGES, localizeMarketingPath } from '../../constants/marketingSeo';
import { isSubdomainStoreMode } from '../../utils/storeUtils';
import { BRAND } from '../../theme/brandTokens';

const linkSx = {
  color: BRAND.textSubtle,
  textDecoration: 'none',
  fontSize: '0.8rem',
  fontWeight: 600,
  '&:hover': { color: BRAND.accentText, textDecoration: 'underline' },
};

/**
 * Plain links to this page in every language. The switcher is a select, which crawlers
 * cannot follow; these links make each language version discoverable from the others.
 */
const MarketingLanguageLinks = ({ path }) => {
  const { t, i18n } = useTranslation();
  const activeLang = normalizeLanguage(i18n.resolvedLanguage || i18n.language);

  if (isSubdomainStoreMode()) {
    return null;
  }

  return (
    <Stack component="nav" direction="row" spacing={2} justifyContent="center" aria-label={t('language')}>
      {MARKETING_LANGUAGES.map((code) => (
        <MuiLink
          key={code}
          component={RouterLink}
          to={localizeMarketingPath(path, code)}
          hrefLang={code}
          lang={code}
          aria-current={code === activeLang ? 'page' : undefined}
          onClick={(event) => {
            if (code === activeLang) {
              event.preventDefault();
              return;
            }
            event.preventDefault();
            i18n.changeLanguage(code);
          }}
          sx={{ ...linkSx, ...(code === activeLang && { color: BRAND.accentText }) }}
        >
          {t(`languages.${code}`, { lng: code })}
        </MuiLink>
      ))}
    </Stack>
  );
};

export default MarketingLanguageLinks;
